import "../k";

function addBadge(isCorrect, comps?) {
  const badgeSprite = isCorrect ? "right" : "wrong";
  const badge = add([
    sprite(badgeSprite),
    anchor("center"),
    animate(),
    ...comps,
  ]);
  badge.add([
    text(isCorrect ? "Right!" : "Nope!", { font: "rumeur" }),
    anchor("center"),
    pos(0, 38),
    color(Color.BLACK),
  ]);
  badge.animate("scale", [vec2(0, 0), vec2(1, 1)], {
    duration: 1.5,
    loops: 1,
    easing: easings.easeOutElastic,
  });
  badge.animate("angle", [0, -15, 10, 0], {
    duration: 0.5,
    loops: 1,
    easing: easings.easeInOutCubic,
  })
  const posCalculated = badge.pos;
  badge.onUpdate(() => {
    badge.pos = [posCalculated.x, posCalculated.y + Math.sin(time() * 10) * 4];
  });
  return badge;
}

export { addBadge };
